import ParksDetailBySector from "./ParksDetailBySector";
import ParksDetailByOccupancy from "./ParksDetailByOccupancy";
export { ParksDetailBySector, ParksDetailByOccupancy };
